export const defaultUrl = process.env.REACT_APP_PHONESHEET_URL;
export const apiServerUrl = process.env.REACT_APP_API_SERVER;
export const profileUrl = `${process.env.REACT_APP_PROFILE_URL}/profile`;
export const companyProfileUrl = `${process.env.REACT_APP_PROFILE_URL}/company`;
